import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    // Vous pouvez afficher un spinner de chargement ici si vous le souhaitez
    return <div>Chargement de l'authentification...</div>; 
  }

  // Si l'utilisateur n'est pas authentifié (pas d'utilisateur et chargement terminé), rediriger vers la page de connexion
  if (!user) {
    // Stocker l'URL actuelle pour rediriger l'utilisateur après la connexion
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Si l'utilisateur est authentifié, afficher le contenu protégé
  return <>{children}</>;
};

export default ProtectedRoute;
